<label class="fakelabel">Deselezionando il check 'Fondo rischi'
	confermi di volerne eliminare la sezione</label>
<input name="{{'f_conferma_check_' + randomEnd}}" id="{{'f_conferma_check_' + randomEnd}}"
	[(ngModel)]="modelCheck"
	(ngModelChange)="modelChanged()"
	[ngModelOptions]="{standalone: true}" type="checkbox">

<label for="{{'f_conferma_check_' + randomEnd}}" class="accettazione">Accetto</label>